<template>
  <div class="animated fadeIn" style="height:100%; width:auto;">
    <b-card>
      <div slot="header">
        {{this.$route.meta.title}}
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="7">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>No.Kontrak</label>
                </b-input-group-prepend>
                <b-form-input
                  readonly
                  v-model="model.no_kontrak"
                  @keyup.13.native="lkuPinjamanShow=true"
                  :state="!$v.model.pinjamankey.$error"
                ></b-form-input>
                <b-input-group-append v-if="!isdetail">
                  <b-btn text="Button" @click="lkuPinjamanShow=true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Tgl. Kontrak</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.tgl_kontrak" type="date" disabled></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend>
              <label>Debitur</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.CustName" disabled></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Penggunaan</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.uraian" disabled></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="5">
          <b-col lg="12">
            <b-input-group>
              <b-input-group-prepend v-if="model.model_pinjaman=='PAB'">
                <label>Pokok Pinjaman</label>
              </b-input-group-prepend>
              <b-input-group-prepend v-else>
                <label>Plafond Pinjaman</label>
              </b-input-group-prepend>
              <my-number
                v-if="model.model_pinjaman=='PAB'"
                class="form-control text-right"
                v-model="model.principal"
                :precision="2"
                disabled
              ></my-number>
              <my-number
                v-else
                class="form-control text-right"
                v-model="model.principal"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Jangka Waktu</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.tenor"
                :precision="0"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">bulan</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Bunga per tahun</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.bunga_tarifthn"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">%</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-if="model.model_pinjaman=='PAB'">
              <b-input-group-prepend>
                <label>Angsuran per bulan</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.installment_amount"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-else>
              <b-input-group-prepend>
                <label>Bunga Over Draft</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.bungaod_tarifthn"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">%</span>
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
        </b-col>
      </b-row>
      <hr />
      <b-card border-variant="info" align="center" no-body v-if="model.model_pinjaman">
        <template v-slot:header>
          <h6>Detail {{model.model_pinjaman=='PAB'?'Denda':'Bunga'}} Harian</h6>
        </template>

        <b-table
          class="mb-0"
          ref="table"
          outlined
          responsive
          striped
          hover
          small
          style="font-size:smaller;"
          :items="tblData.items"
          :fields="tblFields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit"
          :busy="isBusy"
          show-empty
        >
          <template v-slot:cell(tgl_denda)="data">{{ data.item.tgl_denda | moment("DD/MM/YY") }}</template>
          <template v-slot:cell(tgl_bunga)="data">{{ data.item.tgl_bunga | moment("DD/MM/YY") }}</template>
          <template
            v-slot:cell(nilai_denda)="data"
          >{{ data.item.nilai_denda | numFormat('0,0.00') }}</template>
          <template v-slot:cell(angsuran_pokok)="data">{{ data.item.angsuran_pokok | numFormat('0,0.00') }}</template>
          <template v-slot:cell(angsuran)="data">{{ data.item.angsuran | numFormat('0,0.00') }}</template>
          <template v-slot:cell(angsuran_bunga)="data">{{ data.item.angsuran_bunga | numFormat('0,0.00') }}</template>
          <template v-slot:cell(sisa_pjmnpokok)="data">{{ data.item.sisa_pjmnpokok | numFormat('0,0.00') }}</template>

          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(empty)="data">
            <h4>{{ data.emptyText }}</h4>
          </template>
          <template v-slot:custom-foot>
            <b-tr>
              <b-td colspan="2">
                <h6 class="text-right">Total</h6>
              </b-td>
              <b-td v-if="model.model_pinjaman == 'PAB'">
                <h6 class="text-right">{{ totalpokok| numFormat('0,0.00')}}</h6>
              </b-td>
              <b-td>
                <h6 class="text-right">{{total | numFormat('0,0.00')}}</h6>
              </b-td>
            </b-tr>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>
          <template v-slot:cell(action)="data">
            <div class="text-center">
              <b-dropdown text="Action" size="sm">
                <b-dropdown-item v-if="data.item.final==0">Revisi</b-dropdown-item>
                <b-dropdown-item v-if="data.item.model_pinjaman=='PAB'">Jadwal Angsuran</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item v-if="data.item.cair==1">Detail Denda/Bunga RK</b-dropdown-item>
                <b-dropdown-item v-if="data.item.cair==1">Collection Activity</b-dropdown-item>
                <b-dropdown-item v-if="data.item.cair==1">Permohonan Pelunasan</b-dropdown-item>
                <b-dropdown-item v-if="data.item.cair==1">History Payment & Settlement</b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </b-table>
        <b-row class="mt-2">
          <b-col cols="4">
            <div>
              Showing {{(tblData.page - 1) * tblData.limit + 1}}
              to
              <span
                v-if="((tblData.page * tblData.limit)>tblData.total)"
              >{{tblData.total}}</span>
              <span v-else>{{tblData.page * tblData.limit}}</span>
              of {{tblData.total}} entries
            </div>
          </b-col>
          <b-col cols="4">
            <b-form-group label-cols="3" label style="margin-top:0 !important;">
              <b-input-group>
                <b-input-group-prepend class="mr-2">
                  <label>Limit per page</label>
                </b-input-group-prepend>
                <div class="d-flex">
                  <b-form-select
                    :options="[10, 15, 20, 25,50,75,100]"
                    :plain="true"
                    v-model="tblData.limit"
                    size="sm"
                    style="width:80px"
                  />
                </div>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-pagination
              align="right"
              :total-rows="tblData.total"
              :per-page="tblData.limit"
              v-model="tblData.page"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-card>
    </b-card>
    <b-modal
      v-model="lkuPinjamanShow"
      size="lg"
      :hide-footer="true"
      title="Daftar Pinjaman"
      :centered="true"
    >
      <lku-pinjaman @click="onSelectLkuPinjaman" :modelpinjaman="model.model_pinjaman"></lku-pinjaman>
    </b-modal>
  </div>
</template>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
// import vDim from "../lookup/dim";
import lkuPinjaman from "./lkuPinjaman";
import denbun from "../../apis/dendabungakredit";
// import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { myNumber, lkuPinjaman },
  mixins: [validationMixin],
  validations: {
    model: {
      pinjamankey: { required },
    },
  },
  data() {
    return {
      model: { pinjamankey: "" },
      lkuPinjamanShow: false,
      isdetail: false,
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1: this.$store.state.user.tglaktif,
        tgl2: this.$store.state.user.akhirbln,
        sortBy: "nokontrak",
        sortDesc: false,
      },
      isBusy: false,
      total: 0,
      totalpokok: 0,
      appName: this.$route.name,
    };
  },
  props: ["modelpinjaman"],
  computed: {
    tblFields() {
      const fields = [
        {
          key: `${
            this.model.model_pinjaman == "PAB" ? "angsuran_ke" : "principal"
          }`,
          label: `${
            this.model.model_pinjaman == "PAB"
              ? "Denda Atas Angsuran Ke -"
              : "Pokok "
          }`,
          thStyle: "width:50px",
          thClass: "text-center",
          tdClass: `${
            this.model.model_pinjaman == "PAB" ? "text-center" : "text-right"
          }`,
          sortable: true,
        },
        {
          key: `${
            this.model.model_pinjaman == "PAB" ? "tgl_denda" : "tgl_bunga"
          }`,
          label: `Tgl. ${
            this.model.model_pinjaman == "PAB" ? "Denda" : "Bunga"
          }`,
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "angsuran_pokok",
          label: "Pokok",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: `${
            this.model.model_pinjaman == "PAB" ? "nilai_denda" : "angsuran_bunga"
          }`,
          label: `${
            this.model.model_pinjaman == "PAB" ? "Denda" : "Bunga"
          } (IDR)`,
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
      ];
      return fields;
    },
  },
  created: async function () {
    if (this.$route.params.pinjamankey) {
      toastr.info("Loading Payment Detail, please wait");
      try {
        this.model.pinjamankey = this.$route.params.pinjamankey;
        this.isdetail = true;
        this.getData();
        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    } else {
      this.model.model_pinjaman = this.modelpinjaman;
    }
  },
  beforeUpdate: function () {
    if (this.modelpinjaman) {
      this.model.model_pinjaman = this.modelpinjaman;
    }

    if (this.appName != this.$route.name) {
      this.appName = this.$route.name;
      this.model = { pinjamankey: "" };
      this.total = 0;
      this.tblData = {
        page: 1,
        limit: 15,
        total: 0,
        tgl1: this.$store.state.user.tglaktif,
        tgl2: this.$store.state.user.akhirbln,
        sortBy: "nokontrak",
        sortDesc: false,
      };
    }
  },
  methods: {
    onSelectLkuPinjaman(_selected) {
      this.model.pinjamankey = _selected.pinjamankey;
      this.getData();
      this.lkuPinjamanShow = false;
    },
    getData: async function () {
      const obj = {
        pinjamankey: this.model.pinjamankey,
      };
      const [data] = await denbun.dendabungaharian(obj);
      const pinjaman = data[0][0];
      for (const key in pinjaman) {
        this.model[key] = pinjaman[key];
      }
      this.model.tgl_kontrak = moment(this.model.tgl_kontrak).format(
        "YYYY-MM-DD"
      );
      const bunga = data[1];
      const denda = data[2];
      this.tblData.items = this.model.model_pinjaman == "PAB" ? denda : bunga;
      let total = 0,
        totalpokok = 0;
      if (this.model.model_pinjaman == "PAB") {
        denda.map((x) => {
          total += x.nilai_denda || 0;
          totalpokok += x.angsuran_pokok;
        });
      } else {
        bunga.map((x) => {
          total += x.angsuran_bunga || 0;
          totalpokok += x.angsuran_pokok;
        });
      }

      this.total = total;
      this.totalpokok = totalpokok;
      this.tblData.total = denda.length;
    },
    close() {
      router.go(-1);
      //   router.push("home");
    },
  },
};
</script>
